<template>
  <div>
    <card-logo-and-numbers :card="payment" />
  </div>
</template>

<script>
import CardLogoAndNumbers from '../CardLogoAndNumbers.vue';

export default {
  components: { CardLogoAndNumbers },

  props: ['payment'],
};
</script>
